import React, { useEffect, useState } from "react";
import { RefreshCw, DownloadCloud, Loader2, History, Save, Link, FlaskConical } from "lucide-react";
import { toast } from "sonner";
import { reviewsApi, btnCls } from "./shared";

const HINT = "3 konumunuzun Google Maps linkleri (maps.app.goo.gl/… veya google.com/maps/place/…). Her satıra bir link. Yorumlar Apify üzerinden çekilir; booking ref olmadığı için yorumcu adı + tarih ile rezervasyon önerisi üretilir.";

export default function GoogleSourceActions({ s, onChanged }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(null);
  useEffect(() => { setText((s.urls || []).join("\n")); }, [s.urls]);
  const dirty = text.trim() !== (s.urls || []).join("\n").trim();
  const p = s.progress || {};
  const running = s.running || s.last_status === "running";

  const run = async (fn, key, okMsg) => {
    setBusy(key);
    try { const d = await fn(); toast.success(typeof okMsg === "function" ? okMsg(d) : okMsg); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "İşlem başarısız"); }
    setBusy(null);
  };
  const save = () => run(() => reviewsApi.setSourceUrls("google", text.split(/\n+/)), "save", d => `${d.urls.length} link kaydedildi`);
  const hasUrls = !!(s.urls || []).length;

  return (
    <div className="mt-3 space-y-2">
      <p className="text-[11px] text-slate-500 leading-relaxed">{HINT}</p>
      <textarea value={text} onChange={e => setText(e.target.value)} rows={Math.min(6, Math.max(2, text.split("\n").length))} spellCheck={false}
        placeholder="https://maps.app.goo.gl/…" data-testid="google-urls-input"
        className="w-full bg-slate-900 border border-slate-700 text-slate-200 text-[11px] font-mono rounded-lg px-3 py-2 placeholder:text-slate-600 focus:border-blue-500 outline-none resize-y" />
      <div className="flex flex-wrap gap-2">
        <button onClick={save} disabled={!!busy || !dirty} className={`${btnCls} ${dirty ? "bg-blue-600 hover:bg-blue-500 text-white" : "bg-slate-700 text-slate-300"}`} data-testid="google-save-urls-btn">
          {busy === "save" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Linkleri Kaydet
        </button>
        <button onClick={() => run(() => reviewsApi.googleSync("incremental", 5), "test", d => d.started ? "Test: 5 yorum çekiliyor…" : "Başlatılamadı (link yok veya zaten çalışıyor)")}
          disabled={!hasUrls || !!busy || running} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200`} data-testid="google-test-btn">
          <FlaskConical className="w-4 h-4" /> Test (5 yorum)
        </button>
        <button onClick={() => run(() => reviewsApi.googleSync("incremental"), "inc", d => d.started ? "Yeni yorumlar çekiliyor…" : "Başlatılamadı (link yok veya zaten çalışıyor)")}
          disabled={!hasUrls || !!busy || running} className={`${btnCls} bg-emerald-600 hover:bg-emerald-500 text-white`} data-testid="google-sync-btn">
          <RefreshCw className="w-4 h-4" /> Yeni Yorumları Çek
        </button>
        <button onClick={() => { if (window.confirm("Tüm Google yorumları (eskiler dahil) çekilecek, Apify kredisi harcar, dakikalar sürebilir. Devam?")) run(() => reviewsApi.googleSync("full"), "full", "Tüm geçmiş çekiliyor…"); }}
          disabled={!hasUrls || !!busy || running} className={`${btnCls} bg-slate-700 hover:bg-slate-600 text-slate-200`} data-testid="google-full-sync-btn">
          <DownloadCloud className="w-4 h-4" /> Tüm Geçmişi Çek
        </button>
      </div>
      {running && (
        <div className="flex items-center gap-2 text-xs text-emerald-300 bg-emerald-900/20 border border-emerald-800/40 rounded-lg px-3 py-2" data-testid="google-progress">
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
          {p.mode === "full" ? "Tüm geçmiş" : "Yeni yorumlar"} çekiliyor: {p.fetched ?? 0} yorum{p.inserted ? ` · ${p.inserted} yeni` : ""}{p.suggested ? ` · ${p.suggested} öneri` : ""}
        </div>
      )}
      {!running && s.last_status === "ok" && p.fetched != null && (
        <div className="text-[11px] text-slate-400 flex items-center gap-1" data-testid="google-last-result">
          <History className="w-3 h-3" /> Son çekim: {p.fetched} yorum · {p.inserted} yeni · {p.matched} ref · {p.suggested} isim önerisi{p.seconds ? ` · ${p.seconds}s` : ""}
        </div>
      )}
      {hasUrls && <div className="text-[11px] text-slate-500 flex items-center gap-1"><Link className="w-3 h-3" /> {(s.urls || []).length} konum · her gün 23:58'de otomatik</div>}
    </div>
  );
}
